import { apolloCache } from '../src/createClient.ts';
import type { BroadcastConfigurableInMemoryCache } from '../src/broadcastConfigurableInMemoryCache.ts';

export { createClient, resetApolloStats } from '../src/createClient.ts';
export type { BroadcastConfigurableInMemoryCache };

export function getApolloCache() {
	return apolloCache;
}
